(function() {
  'use strict';

  PropAdminController.$inject = [];

  function PropAdminController() {
    var ctrl = this;

    ctrl.$onInit = function() {

      ctrl.onResolveDisabled({
        $event: {
          disabled: false
        }
      });

      ctrl.onResolveProperties({
        $event: {
          properties: ctrl.properties
        }
      });
    }

    ctrl.$onChanges = function(changes) {
    }
  }

  angular
    .module('tyallsApp')
    .controller('PropAdminController', PropAdminController);
})();
